import {
    Row,
    Col,
    Container,
    Popover,
    PopoverHeader,
    PopoverBody,
    Collapse,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';
import React, {useEffect, useRef, useState} from "react";
import token from '../AuthToken';
import Config from "../Config";
import {NavLink, useNavigate} from 'react-router-dom';
import _ from "../Trans";
import {SquadInRanking, RankingSquadHeader, SquadInRankingTableHeader} from "./SquadRanking";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faCircleInfo,
    faChevronLeft,
    faMoneyBillTransfer,
    faRankingStar,
    faFutbol,
    faTrashCan,
    faQrcode,
    faRightFromBracket,
    faCircleCheck,
    faPencil,
} from "@fortawesome/free-solid-svg-icons";
import {faPencilSlash} from "@danieloi/pro-regular-svg-icons";
import {faTelegram, faWhatsapp} from "@fortawesome/free-brands-svg-icons";
import {toast} from "react-toastify";
import Toggle from "./Toggle";
import QRCode from "react-qr-code";
import ReactGA from "react-ga4";
import {LessButton, MoreButton} from "./MoreLessButtons";

const MINILEAGUE_TYPE_SUPERMANAGER = 1;
const MINILEAGUE_TYPE_BROKER = 2;
const MINILEAGUE_TYPE_GOALS = 3;

const goalsAndStopsText = _("Goals + Stops");
const creatingText = _("Creating...");
const goalsHelpText = _("In this mode, the score comes only from goals.<br/><br/>Goalkeepers also score for stopped shots.");
const ceoText = _('CEO of the league');
const signText = _('Sign here');
const refuseText = _('Refuse');
const leagueNamePlaceholder = _("My mini league");
const detailsAndInviteText = _("Details and Invite friends");
const noMiniLeaguesMessage = _('You are not into any mini league.');
const newMiniLeagueText = _('New mini league');
const createMiniLeagueText = _('Create mini league');
const closeMiniLeagueText = _('Close');
const classicGameText = _("Classic game. Your squads will have a mini league with the same point rules.");

const confirmDeleteText = _("Are you sure you want to delete this league?");
const confirmLeaveText = _("Are you sure you want to leave this league?");

const alertSetMiniLeagueNameText = _('Please name your mini league');


let audio = new Audio(Config.signatureSoundUrl);

export default function MiniLeagues({data=null, display={}}) {
    const [creatingMiniLeague, setCreatingMiniLeague] = useState(false)
    const [miniLeagueName, setMiniLeagueName] = useState(false)
    const [miniLeagueType, setMiniLeagueType] = useState(false)
    const [miniLeagueCreated, setMiniLeagueCreated] = useState(null);
    const [miniLeagues, setMiniLeagues] = useState([]);
    const [createMiniLeagueDisabled, setCreateMiniLeagueDisabled] = useState(false);

    const closeMiniLeague = function() {
        setCreatingMiniLeague(false)
    }
    const fetchMiniLeagues = function() {
        fetch(Config.miniLeagueUrl, {
            headers: {
                Authorization: 'Token ' + token,
                'Content-Type': 'application/json'
            }
        })
        .then((e) => {
            if (e.status < 300) {
                return Promise.resolve(e.json())
            }
            return Promise.reject(e)
        })
        .then(e => setMiniLeagues(e.results))
    }

    useEffect(() => fetchMiniLeagues(), []);

    const createMiniLeague = function() {
        if(!miniLeagueName) {
            alert(alertSetMiniLeagueNameText);
            return;
        }
        setCreateMiniLeagueDisabled(true);
        const data = new FormData();
        data.append('name', miniLeagueName);
        data.append('type', miniLeagueType);
        fetch(Config.miniLeagueUrl, {
            method: 'POST',
            headers: {
                Authorization: 'Token '+token,
                // 'Content-Type': 'application/json'
            },
            body: data
        })
        .then(function(e) {
            if(e.status < 300) {
                return Promise.resolve(e.json())
            }
            let error = {
                code: e.status
            }
            Object.assign(error, e.json())
            return Promise.reject(error)
        })
        .then((e, data) => {
            setMiniLeagueCreated(e.code);
        }).catch(
            (e) => {
                console.error("Error creating league", e);
                toast.error(_('All fields are required'), Config.toastConfig)
            }
        )
        .finally(() => setCreateMiniLeagueDisabled(false));
    }

    useEffect(() => fetchMiniLeagues(), []);
    useEffect(function() {
        if(miniLeagueCreated !== null) {
            window.location.href = Config.miniLeagueReactUrl + '?league=' + miniLeagueCreated
        }
    }, [miniLeagueCreated]);
    useEffect(() => setCreatingMiniLeague(false), [miniLeagueCreated]);

    const changeMiniLeagueName = function(e) {
        setMiniLeagueName(document.getElementById('id-minileague-name').value)
    }

    const changeMiniLeagueType = function(e) {
        setMiniLeagueType(e.target.dataset.value);
    }

    const miniLeaguesRendered = miniLeagues.map((league, index) => <MiniLeagueSelector key={index} league={league}/>)

    return <div style={display} className="pl-0 pr-0">
        <Row className="">
        {creatingMiniLeague ? "" :
            <>
                <Col xs={4}></Col>
                <Col xs={4} id="create-mini-league" className="text-center mt-4 mb-2">
                    <button type="button" className="btn btn-info pt-3 pb-3 w-100"
                            onClick={() => setCreatingMiniLeague(true)} style={{color: 'white'}}>
                        <div className="text-center h6 w-100 m-0">{newMiniLeagueText}</div>
                    </button>
                </Col>
                <Col xs={4}></Col>
            </>
        }
        </Row>
        {creatingMiniLeague &&
        <Row className="mt-3 mb-3 ml-1 mr-1 p-2 create-mini-league-pill">
            <Col xs={12} id="new-mini-league">
                <label htmlFor="id-minileague-name" className="h5">{_("Name")}</label><br/>
                <input type="text" name="minileague-name" id="id-minileague-name" placeholder={leagueNamePlaceholder} className="form-control" onChange={() => changeMiniLeagueName(this)}/><br/>
            </Col>
            <Col xs={12} className="mb-2">
                <label htmlFor="" className="h5">{_("Mode")}</label><br/>
            </Col>
            <MiniLeagueRadioButton text={_('Classic')} helpText={classicGameText} icon={faRankingStar} onClickHandler={changeMiniLeagueType} type={1}/>
            <MiniLeagueRadioButton text={_('Agent')} helpText={_("Player agent mode. The best squad will be the one that has the maximum amount of money.<br/><br/>Check out good players with low valuation, hire them and sell when for a yield!")} icon={faMoneyBillTransfer} onClickHandler={changeMiniLeagueType} type={2}/>
            <MiniLeagueRadioButton text={goalsAndStopsText} helpText={goalsHelpText} icon={faFutbol} onClickHandler={changeMiniLeagueType} type={3}/>
            <Col xs={12} className="text-center mt-3 mb-4">
                <button onClick={closeMiniLeague} className="btn btn-primary pt-3 pb-3">{closeMiniLeagueText}</button>&nbsp;&nbsp;
                <button disabled={createMiniLeagueDisabled} onClick={createMiniLeague} className="btn btn-primary pt-3 pb-3">{createMiniLeagueDisabled ? creatingText : createMiniLeagueText}</button>
            </Col>
        </Row>
        }
        {miniLeagues.length === 0 ?
            (
                <Col sm={12} id="private-league" className="text-center mt-2">
                    {noMiniLeaguesMessage}
                </Col>
            )
            :
            (
                <Row className="">
                {miniLeaguesRendered}
                </Row>
            )
        }
    </div>
}

function MiniLeagueRadioButton({text, helpText, icon, onClickHandler, type}) {
    const idAndTarget = 'info-'+type;
    const [popoverOpen, setPopoverOpen] = useState(false);

    const toggleOpen = function () {
        setPopoverOpen(!popoverOpen);
    }
    const innerHelpText = {__html: helpText}

    return (
        <Col xs={12} className="text-left mb-3">
            <input type="radio" id="id_type" name="type" value={type} data-value={type} onClick={onClickHandler} style={{transform: "scale(2)"}}/>
            <MiniLeagueTitle idAndTarget={idAndTarget} text={text} icon={icon}></MiniLeagueTitle><FontAwesomeIcon icon={faCircleInfo} id={idAndTarget} color="blue" className="ml-2"/>
            <Popover placement="bottom" isOpen={popoverOpen} target={idAndTarget} toggle={toggleOpen} onClick={toggleOpen}>
              <PopoverHeader className="font-weight-bold" style={{color: 'black'}}>{text}</PopoverHeader>
              <PopoverBody dangerouslySetInnerHTML={innerHelpText}></PopoverBody>
            </Popover>
        </Col>
    )
}

function MiniLeagueTitle({text, icon, idAndTarget}) {
    return (
        <span><FontAwesomeIcon icon={icon} id={idAndTarget} className="ml-4"/><span className="h6 ml-2">{text}</span></span>
    )
}

function MiniLeagueSelector({league}) {
    let icon = faRankingStar;
    if(league.type === MINILEAGUE_TYPE_BROKER) {
        icon = faMoneyBillTransfer;
    }
    else if(league.type === MINILEAGUE_TYPE_GOALS) {
        icon = faFutbol;
    }
    return (
        <Col xs={6} md={4} lg={4} className="text-center">
            <NavLink to={"/mini-league/?league="+league.code} style={{'textDecoration': 'none'}}>
                <button type="button" className="btn btn-info w-100 mt-2 d-flex justify-content-between align-center" style={{height: '60px', alignItems: 'center'}}>
                    <FontAwesomeIcon icon={icon} className="mr-2"/>
                    <div className="text-center h6 w-100 m-0">{league.name}</div>
                </button>
            </NavLink>
        </Col>
    )
}

function MiniLeague() {
    const [miniLeague, setMiniLeague] = useState({name: '', code: '', squads: []})
    const [position, setPosition] = useState(15)
    const [points, setPoints] = useState(0)
    const [isCollapsed, setIsCollapsed] = useState(false)
    const [showQr, setShowQr] = useState(false)
    const [modalComponent, setModalComponent] = useState(<div></div>)
    const [teamSelected, setTeamSelected] = useState(null);
    const [editingMiniLeague, setEditingMiniLeague] = useState(null);
    const [image, setImage] = useState();
    const [background, setBackground] = useState();
    const [name, setName] = useState();
    const [text, setText] = useState();

    let queryParameters = new URLSearchParams(window.location.search)
    let signUrl = Config.miniLeagueUrl + queryParameters.get('league')+'/';

    function sign() {
        fetch(signUrl, {
            headers: {
                Authorization: 'Token ' + token,
                'Content-Type': 'application/json'
            },
            method: 'PUT',
            body: JSON.stringify({team_selected: teamSelected})
        })
        .then((e) => {
            if (e.status < 300) {
                return Promise.resolve(e)
            }
            if(e.status === 401) {
                window.location.href = Config.logoutPage;
            }
            return Promise.reject(e)
        })
        .then((e) => e.json())
        .then((e) => window.location.reload())
        .catch((e) => {
            console.error("Something went wrong signing contract to join mini-league")
            console.error(e)
            e = e.json()
            console.error(e);
        })
    }

    function rejoin() {
        fetch(signUrl, {
            headers: {
                Authorization: 'Token ' + token,
                'Content-Type': 'application/json'
            },
            method: 'PUT'
        })
        .then((e) => {
            if (e.status < 300) {
                return Promise.resolve(e)
            }
            if(e.status === 401) {
                window.location.href = Config.logoutPage;
            }
            return Promise.reject(e)
        })
        .then((e) => e.json())
        .then((e) => window.location.reload())
        .catch((e) => {
            e = e.json()
            console.error("Something went wrong signing contract to rejoin mini-league")
            console.error(e)
        })
    }

    audio.onerror = sign;
    audio.onended = sign;

    const signatureImg = useRef(null);
    const signatureButton = useRef(null);

    const signIntoMinileague = function(e) {
        signatureImg.current.classList.remove('d-none')
        signatureButton.current.classList.add('d-none')

        try {
            audio.play();
        }catch(e) {
            sign();
            console.error(e)
        }
    }

    const rejoinMinileague = function() {
        signatureImg.current.classList.remove('d-none')
        signatureButton.current.classList.add('d-none')

        try {
            audio.play();
        }catch(e) {
            rejoin();
            console.error(e)
        }
    }

    const changeTeamSelected = function(e) {
        setTeamSelected(e.target.value);
    }

    const setMiniLeagueData = function(e) {
        setMiniLeague(e);
        setImage(e.image);
        setBackground(e.background);
        setName(e.name);
        setText(e.text);
    }

    const fetchMiniLeague = function() {
        fetch(signUrl, {
            headers: {
                Authorization: 'Token ' + token,
                'Content-Type': 'application/json'
            }
        })
        .then((e) => {
            if (e.status < 300) {
                return Promise.resolve(e.json())
            }
            if(e.status === 401) {
                window.location.href = Config.logoutPage;
            }
            return Promise.reject(e)
        })
        .then(e => setMiniLeagueData(e))
        .catch((e) => {
            if(e?.teams != null && e.teams.length === 1) {
                setTeamSelected(e.teams[0][0]);
            }
            if(e.status === 403) {
                new Promise((resolve, reject) => resolve(e.json())).then((e) => {
                        const modalTitle = _('Invitation to') + " <b>" + e.league_name + "</b>"
                        const wantsText = _('wants your team to join this league, which is part of the')
                        const tournamentText = _('tournament')
                        const joinText = _('Please sign below to accept and join the mini league')
                        setModalComponent(
                            <Modal isOpen={true} className="font-color">
                                <ModalHeader>
                                    <span dangerouslySetInnerHTML={{__html: modalTitle}}/>
                                </ModalHeader>
                                <ModalBody>
                                    {_('Dear')} <b>{e.username}</b>,<br/>
                                    <br/>
                                    <b>{e.ceo}</b>, {ceoText} <b>{e.league_name}</b>,&nbsp;
                                    {wantsText}
                                    &nbsp;{e.tournament_name}&nbsp;
                                    {tournamentText}.<br/>
                                    <br/>
                                    {e.teams.length > 1 ?
                                        <>
                                            Selecciona uno de tus equipos para que se inscriba en esta liga.<br/>
                                            <center>
                                            <select style={{border: '0', backgroundColor: 'unset'}} id="id_selected_team" name="selected_team" onChange={changeTeamSelected}>
                                            {e.teams.map((team, index) => (
                                                <option id={index} value={team[0]}>{team[1]}</option>
                                            ))}
                                            </select>
                                            </center>
                                            Esta decisión es definitiva y se prolongará hasta el final del torneo.<br/>
                                        </>
                                        :
                                        <>
                                            Se inscribirá tu único equipo:&nbsp;
                                            <b>{e.teams[0][1]}</b>
                                            <input type="hidden" id="id_selected_team" name="selected_team" value={e.teams[0][0]}/>
                                            <br/>
                                        </>
                                    }
                                    <br/>
                                    {joinText}.<br/><br/>
                                    <div className="text-center">
                                        <img id="id_signature" ref={signatureImg} src={Config.signatureImageUrl} alt="Signed" width={"50%"} className="d-none"/>
                                        <button id="id_signature_button" ref={signatureButton} className="btn btn-default"
                                                onClick={signIntoMinileague}
                                                style={{textDecoration: 'underline', border: '1px solid grey'}}>
                                            ({signText})
                                        </button>
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <NavLink to="/ranking/">
                                        <button className="btn btn-danger">{refuseText}</button>
                                    </NavLink>
                                </ModalFooter>
                            </Modal>
                        )
                    }
                )
            }
            else if(e.status === 417) {
                new Promise((resolve, reject) => resolve(e.json())).then((e) => {
                        const modalTitle = _('Rejoin ') + " <b>" + e.league_name + "</b>"
                        const wantsText = _('allows you to rejoin this league, which is part of the')
                        const tournamentText = _('tournament')
                        const joinText = _('Please sign below to accept and join the mini league')
                        const joinText2 = _(' with your team ')
                        setModalComponent(
                            <Modal isOpen={true} className="font-color">
                                <ModalHeader>
                                    <span dangerouslySetInnerHTML={{__html: modalTitle}}/>
                                </ModalHeader>
                                <ModalBody>
                                    {_('Dear')} <b>{e.username}</b>,<br/>
                                    <br/>
                                    <b>{e.ceo}</b>, {ceoText} <b>{e.league_name}</b>,&nbsp;
                                    {wantsText}
                                    &nbsp;{e.tournament_name}&nbsp;
                                    {tournamentText}.<br/>
                                    <br/>
                                    {joinText}{joinText2}{e.squad_name}.<br/><br/>
                                    <div className="text-center">
                                        <img id="id_signature" ref={signatureImg} src={Config.signatureImageUrl} alt="Signed" width={"50%"} className="d-none"/>
                                        <button id="id_signature_button" ref={signatureButton} className="btn btn-default"
                                                onClick={rejoinMinileague}
                                                style={{textDecoration: 'underline', border: '1px solid grey'}}>
                                            ({signText})
                                        </button>
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <NavLink to="/ranking/">
                                        <button className="btn btn-danger">{refuseText}</button>
                                    </NavLink>
                                </ModalFooter>
                            </Modal>
                        )
                    }
                )
            }
            else {
                console.error(e)
            }
        })
    }

    const navigate = useNavigate();
    const postDeleteMiniLeague = function() {
        fetch(signUrl, {
            headers: {
                Authorization: 'Token ' + token,
                'Content-Type': 'application/json'
            },
            method: 'DELETE'
        })
        .then((e) => {
            if (e.status < 300) {
                return Promise.resolve(e)
            }
            return Promise.reject(e)
        })
        .then((e) => e.json)
        .then((e) => navigate('/ranking/'))
        .catch((e) => {
            e = e.json()
            console.error(e)
        })
    }

    const deleteMiniLeague = function() {
        if(window.confirm(confirmDeleteText)) {
            postDeleteMiniLeague()
        }
    }

    const leaveMiniLeague = function(){
        if(window.confirm(confirmLeaveText)) {
            postDeleteMiniLeague();
        }
    }

    const findMiniLeagueSquadData = function(e) {
        // sort squads by type of minileague
        if(miniLeague.type === MINILEAGUE_TYPE_BROKER) {
            miniLeague.squads.sort(function(a, b) {
                if(a.current_value < b.current_value) return 1;
                else if(a.current_value > b.current_value) return -1;
                return 0;
            });
        }
        else if(miniLeague.type === MINILEAGUE_TYPE_GOALS) {
            miniLeague.squads.sort(function(a, b) {
                if(a.goals_and_stops < b.goals_and_stops) return 1;
                else if(a.goals_and_stops > b.goals_and_stops) return -1
                return 0;
            });
        }

        for(let i = 0; i < miniLeague.squads.length; i++) {
            if(miniLeague.squad_name === miniLeague.squads[i].name) {
                let value = i+1;
                setPosition(value)
                if(miniLeague.type === MINILEAGUE_TYPE_SUPERMANAGER) {
                    setPoints(miniLeague.squads[i].latest_points)
                }
                else if(miniLeague.type === MINILEAGUE_TYPE_BROKER) {
                    setPoints(miniLeague.squads[i].current_value)
                }
                else if(miniLeague.type === MINILEAGUE_TYPE_GOALS) {
                    setPoints(miniLeague.squads[i].goals_and_stops)
                }
                break;
            }
        }

        // now prepare last week
        miniLeague.last_week = JSON.parse(JSON.stringify(miniLeague.squads));
        miniLeague.last_week.map((obj) => {
            obj.latest_points = obj.last_week_points; obj.goals_and_stops = obj.last_week_goals_and_stops; return obj;
        })
        if(miniLeague.type === MINILEAGUE_TYPE_BROKER) {
            // pass
        }
        else if(miniLeague.type === MINILEAGUE_TYPE_GOALS) {
            // last_week_goals_and_stops
            miniLeague.last_week.sort(function(a, b) {
                if(a.goals_and_stops < b.goals_and_stops) return 1;
                else if(a.goals_and_stops > b.goals_and_stops) return -1
                return 0;
            });
        }
        else {
            // sort by last_week_points
            miniLeague.last_week.sort(function(a, b) {
                if(a.latest_points < b.latest_points) return 1;
                else if(a.latest_points > b.latest_points) return -1
                return 0;
            });
        }
    }

    useEffect(function() {
        findMiniLeagueSquadData()
    }, [miniLeague]) // eslint-disable-line

    useEffect(() => fetchMiniLeague(), []); // eslint-disable-line

    const share = function(label) {
        ReactGA.event({
            category: "mini-league",
            action: "share",
            label: label
        })
    }

    const toggleQr = function() {
        share("qr")
        setShowQr(!showQr)
    }

    const shareTelegram = function() {
        share("telegram")
    }

    const shareWhatsApp = function () {
        share("whatsapp")
    }
    
    const editMiniLeague = function() {
        setEditingMiniLeague(!editingMiniLeague);
    }

    const updateMiniLeague = function () {
        const data = new FormData();
        data.append('name', name);
        data.append('text', text);
        if(image != null && typeof image !== "string") {
            data.append('image', image, image.name);
        }
        if(background != null && typeof background !== "string") {
            data.append('background', background, background.name);
        }

        fetch(signUrl, {
            method: 'PUT',
            headers: {
                Authorization: 'Token '+token,
            },
            body: data
        })
        .then(function(e) {
            if(e.status < 300) {
                return Promise.resolve(e.json())
            }
            let error = {
                code: e.status
            }
            Object.assign(error, e.json())
            return Promise.reject(error)
        })
        .catch(
            (e) => {
                console.error("on error updating league", e);
                toast.error(_('All fields are required'), Config.toastConfig)
            }
        )
        .finally(() => setEditingMiniLeague(false));
    }

    const inviteText = _('You have been invited to the league')+" "+miniLeague.name+" ";
    const motivationalText = _('Show that you are a handball lover! 🤾');
    const backGroundIcon = {background:"white", borderRadius: "50%"};

    const telegramUrl = "https://telegram.me/share/url?url="+window.location+"&text="+inviteText+motivationalText
    const whatsappUrl = "https://api.whatsapp.com/send?text="+window.location+" "+inviteText+motivationalText

    const hide = {display: 'none'}
    const show = {display: 'block'}
    const [menu1, setMenu1] = useState(hide);
    const [menu2, setMenu2] = useState(show);
    const [miniLeagueStyle, setMiniLeagueStyle] = useState({});

    function handleSetImage(event) {
        const file = event.target.files[0];
        if (file.size > 5242880) { // 5 MB in bytes
          alert(_('File size exceeds 5 MB. Please choose a smaller file.'));
          event.target.value = ''; // clear the file input
        } else {
            setImage(event.target.files[0])
        }
      }

    function handleSetBackground(event) {
        const file = event.target.files[0];
        if (file.size > 5242880) { // 5 MB in bytes
          alert(_('File size exceeds 5 MB. Please choose a smaller file.'));
          event.target.value = ''; // clear the file input
        } else {
            setBackground(event.target.files[0])
        }
      }

    const imageChangeHtml = <>
        <br/>
        <label htmlFor="id_image">{_('Image (max. 5Mb)')}</label>
        <br/>
        <input type="file" name="image" id="id_image" accept="image/*" onChange={handleSetImage}/>
        <br/>
        <label htmlFor="id_background">{_('Background Image (max. 5Mb)')}</label>
        <br/>
        <input type="file" name="background" id="id_background" accept="image/*" onChange={handleSetBackground}/>
    </>

    const editMiniLeagueElements = <>
        <br/>
        <label htmlFor="id_minileague_name">{ _('Name') }</label><br/>
        <input type="text" defaultValue={name} id="id_minileague_name" name="minileague_name"
               onChange={(e) => setName(e.target.value)}
               style={{width: "90%", boxSizing: "border-box"}}/>
        <br/>
            <label htmlFor="id_minileague_text">{ _('Description') }</label><br/>
        <textarea id="id_minileague_text" name="minileague_text"
                  onChange={(e) => setText(e.target.value)} defaultValue={text}
                  style={{width: "90%", boxSizing: "border-box"}}></textarea>
            <br/>
        <button className="btn btn-primary" onClick={updateMiniLeague}>{_('Update')}</button>
    </>

    const getBackgroundImage = function (e) {
        if(typeof background === 'string') {
            return background?.replace("Gremory", "");
        }
        else if(background != null) {
            return URL.createObjectURL(background);
        }
    }

    useEffect(e =>  {
        setMinileagueStyle(miniLeague);
    }, [background, miniLeague]);  // eslint-disable-line

    const setMinileagueStyle = function(miniLeague) {
        if(miniLeague.owner && (miniLeague.image != null || (miniLeague.text != null && miniLeague.text !== '.') || miniLeague.background != null)) {
            setMiniLeagueStyle({
                backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 0) 60%, rgba(229, 233, 238, 1) 100%), url(${getBackgroundImage()})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                width: "100%"
            });
        }
        else {
            setMiniLeagueStyle({});
        }
    }

    return (
        <Container className="mt-4 minileague-container">
            {modalComponent}
            <Row className="mb-2" style={miniLeagueStyle}>
                {miniLeague.image != null || miniLeague.text != null || miniLeague.background != null ?
                    (
                        <>
                        <Col xs={4}>
                            <NavLink to="/ranking/" className="btn btn-primary">
                                <FontAwesomeIcon icon={faChevronLeft}/>
                            </NavLink>
                            {miniLeague.owner &&
                            <div className="btn btn-primary" onClick={editMiniLeague}>
                            <FontAwesomeIcon icon={editingMiniLeague ? faPencilSlash : faPencil}/>
                            </div>
                            }
                        </Col>
                        <Col xs={4} sm={0} className="text-center d-sm-none">
                            {miniLeague.image != null &&
                            <img src={miniLeague.image?.replace('Gremory', '')} style={{width: "auto", height: "100px"}} alt={miniLeague.name}/>
                            }
                            {editingMiniLeague && imageChangeHtml}
                        </Col>
                        <Col xs={0} sm={4} className="text-center d-none d-sm-block">
                            {miniLeague.image != null &&
                            <img src={miniLeague.image?.replace('Gremory', '')} style={{width: "auto", height: "175px"}} alt={miniLeague.name}/>
                            }
                            {editingMiniLeague && imageChangeHtml}
                        </Col>
                        <Col xs={12} sm={0} className="text-center d-none d-sm-block">
                            {editingMiniLeague && editMiniLeagueElements}
                            {!editingMiniLeague &&
                                <>
                                <h1 className="h2 mt-4 text-white">{name} <FontAwesomeIcon icon={faCircleCheck} color="lawngreen" style={{width: '0.6em'}}/></h1>
                                <br/>
                                <div className="font-italic text-white" dangerouslySetInnerHTML={{__html: text.replace("\n", "<br/>")}}></div>
                                </>
                            }
                        </Col>
                        <Col xs={2} sm={0} className="text-center d-sm-none"></Col>
                        <Col xs={2} sm={0} className="text-center d-sm-none"></Col>
                        <Col xs={12} sm={4} className="text-center d-sm-none">
                            {editingMiniLeague && editMiniLeagueElements}
                            {!editingMiniLeague &&
                                <h1 className="h2 minileague-header-text">
                                    {name} <FontAwesomeIcon icon={faCircleCheck} color="lawngreen" style={{width: '0.6em'}}/>
                                </h1>
                            }
                        </Col>
                        <Col xs={2} sm={0} className="text-center d-sm-none"></Col>
                        <Col xs={12} className="font-italic d-sm-none">
                            {!editingMiniLeague &&
                                <div className="font-italic minileague-header-text" dangerouslySetInnerHTML={{__html: text.replace("\n", "<br/>")}}></div>
                            }
                        </Col>
                        </>
                    )
                    :
                    (
                        <>
                        <Col xs={2}>
                            <NavLink to="/ranking/" className="btn btn-primary">
                                <FontAwesomeIcon icon={faChevronLeft}/>
                            </NavLink>
                        </Col>
                        <Col xs={8} sm={8} className="text-center minileague-header-text">
                            <h1 className="h2">{name}</h1>
                        </Col>
                        <Col xs={2} sm={0}></Col>
                        </>
                    )
                }
            </Row>
            <Row>
                <Col xs={12} className="text-center mb-4 mt-2 minileague-header-text">
                    <Toggle text={detailsAndInviteText} setCollapsedHandler={setIsCollapsed}></Toggle>
                </Col>
            </Row >
            <Collapse isOpen={isCollapsed}  className="mb-4 details-and-invite-friends-pill">
                <Row>
                    <Col xs={5}>
                        {_('CEO')}
                    </Col>
                    <Col xs={7} className="text-right mb-3">
                        {miniLeague.ceo}
                    </Col>
                    <Col xs={4}>
                        {_('League type')}
                    </Col>
                    <Col xs={8} className="text-right mb-3">
                        {miniLeague.type === MINILEAGUE_TYPE_SUPERMANAGER && <MiniLeagueTitle id="mini-league-type" text={_('Supermanager')} icon={faRankingStar}></MiniLeagueTitle>}
                        {miniLeague.type === MINILEAGUE_TYPE_BROKER && <MiniLeagueTitle id="mini-league-type" text={_('Agent')} icon={faMoneyBillTransfer}></MiniLeagueTitle>}
                        {miniLeague.type === MINILEAGUE_TYPE_GOALS && <MiniLeagueTitle id="mini-league-type" text={goalsAndStopsText} icon={faFutbol}></MiniLeagueTitle>}
                    </Col>
                </Row>
                <Row>
                <Col xs={5}>
                    {_('Invite friends')}
                </Col>
                <Col xs={7} className="text-right mb-3">
                    <a href={telegramUrl} className="mr-2"  target="_blank" rel="noreferrer" onClick={shareTelegram}>
                    <FontAwesomeIcon icon={faTelegram} style={backGroundIcon} size={"xl"} color={"#0088cc"}/>
                    </a>
                    <a href={whatsappUrl} className="mr-2" target="_blank" rel="noreferrer" onClick={shareWhatsApp}>
                    <FontAwesomeIcon icon={faWhatsapp} size={"xl"} color="white"/>
                    </a>

                    <span onClick={toggleQr}>
                    <FontAwesomeIcon className="mr-2" icon={faQrcode} size={"lg"} color={"white"}/>
                    </span>
                </Col>
                    {showQr &&
                <Col xs={12} className="text-center mb-3">
                    <QRCode value={window.location.href} className="mt-3" size={256}/>
                </Col>
                    }
                </Row>
                {miniLeague.owner && (
                <Row>
                <Col xs={5}>
                    {_('Delete league')}
                </Col>
                <Col xs={7} className="text-right mb-3">
                    <FontAwesomeIcon icon={faTrashCan} color={"red"} onClick={deleteMiniLeague} className="link"/>
                </Col>
                </Row>
                )}
                {!miniLeague.owner && (
                <Row>
                <Col xs={5}>
                    {_('Leave league')}
                </Col>
                <Col xs={7} className="text-right mb-3">
                    <FontAwesomeIcon icon={faRightFromBracket} color={"red"} onClick={leaveMiniLeague} className="link"/>
                </Col>
                </Row>
                )}
            </Collapse>

            <RankingSquadHeader name={miniLeague.squad_name} points={points} position={position} totalTeams={miniLeague.squads.length} type={miniLeague.type}/>

            {miniLeague.type !== MINILEAGUE_TYPE_BROKER &&
            <MiniLeagueRankingHeader setMenu1={setMenu1} setMenu2={setMenu2} show={show} hide={hide}/>
            }

            <MiniLeagueRanking type={miniLeague.type} squads={miniLeague.last_week} menuStyle={menu1}/>
            <MiniLeagueRanking type={miniLeague.type} squads={miniLeague.squads} menuStyle={menu2}/>
        </Container>
    )
}

const MiniLeagueRanking = function({type, squads, menuStyle}) {
    const [currentOffset, setCurrentOffset] = useState(0);
    const requestPrevious = function() {
        let newOffset = currentOffset - 10;
        setCurrentOffset(newOffset)
    }

    const requestMore = function() {
        let newOffset = currentOffset + 10;
        setCurrentOffset(newOffset)
    }

    return (
        <Row className="mt-3" style={menuStyle}>
            <Col xs={12} className="text-center">
                {currentOffset > 0 && <LessButton requestPrevious={requestPrevious}/>}
            </Col>
            <Col xs={12}>
                <table className="table table-striped ranking-striped minileague-ranking">
                    <SquadInRankingTableHeader type={type}></SquadInRankingTableHeader>
                    <tbody>
                    {squads !== undefined && squads.map((squad, index) => index >= currentOffset && index < currentOffset + 10 && <SquadInRanking key={squad.id} squad={squad} index={index} type={type}/>)}
                    </tbody>
                </table>
            </Col>
            <Col xs={12} className="text-center">
                {((currentOffset === 0 && squads?.length > 10) || currentOffset + 10 < squads?.length) && <MoreButton requestMore={requestMore}/>}
            </Col>
        </Row>
    )
}

const headerClasses = 'mb-3 h4 font-weight-bold ranking-header';
const weeklyTitle = _('Last round ranking');
const title = _('Ranking');

const MiniLeagueRankingHeader = function({setMenu1, setMenu2, show, hide}) {
    const removeActive = function(e) {
        setActive('')
    }
    const [active, setActive] = useState('active')

    const selectMenu = function(menu) {
        removeActive()
        if(menu===1) {
            setMenu1(show)
            setMenu2(hide)
        }
        if(menu===2) {
            setMenu1(hide)
            setMenu2(show)
        }
    }

    return (
        <Row id="menu">
            <Col xs={6} className="text-center link" onClick={() => selectMenu(1)}>
                <h3 className={headerClasses} data-menu="1">{weeklyTitle}</h3>
            </Col>
            <Col xs={6} className={"text-center link " + active} onClick={() => selectMenu(2)} onMouseOut={removeActive}>
                <h3 className={headerClasses} data-menu="2">{title}</h3>
            </Col>
        </Row>
    )
}

export {MiniLeague};